<template>
<div class="chapter">
<div class="inner_page">
<p class="img" id="pt1"><img alt="image" height="294" src="images/pg3.jpg" width="400"/></p>
<p class="pn"><span class="epub-b"><span class="epub-sc">PART ONE</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part1.vue?87044a80